import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';


const ContentFilterBar = ({ 
  filters, 
  onFilterChange, 
  onReset,
  contentTypes,
  completionStatuses 
}) => {
  return (
    <div className="bg-card rounded-xl p-4 md:p-6 border border-border shadow-warm mb-4 md:mb-6">
      <div className="flex flex-col lg:flex-row gap-4 items-start lg:items-end">
        <div className="w-full lg:w-64">
          <Input
            type="search"
            label="Search Characters"
            placeholder="Search by character name..."
            value={filters?.search}
            onChange={(e) => onFilterChange('search', e?.target?.value)}
            className="w-full"
          />
        </div>

        <div className="w-full lg:w-56">
          <Select
            label="Content Type"
            placeholder="All content types"
            options={contentTypes}
            value={filters?.contentType}
            onChange={(value) => onFilterChange('contentType', value)}
            clearable
          />
        </div>

        <div className="w-full lg:w-56">
          <Select
            label="Completion Status"
            placeholder="All statuses"
            options={completionStatuses}
            value={filters?.completionStatus}
            onChange={(value) => onFilterChange('completionStatus', value)}
            clearable
          />
        </div>

        <div className="w-full lg:w-auto flex gap-2">
          <Button
            variant="outline"
            onClick={onReset}
            iconName="RotateCcw"
            iconPosition="left"
            className="flex-1 lg:flex-none"
          >
            Reset
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ContentFilterBar;